<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>

    <div>
      <van-list v-if="userInfo.binah_data && userInfo.binah_data.length">
        <van-cell v-for="(item, index) in userInfo.binah_data" :key="index">
          <template #title>
            <div class="item-title">
              <span>{{ item.binahdata_date }}</span>
            </div>
          </template>
          <template #label>
            <div class="item-value">
              <span>HR: {{ item.heartrate }}</span>
              <span>SpO2: {{ item.oxygensaturation }}</span>
              <span>BR: {{ item.breathingrate }}</span>
              <span>SDNN: {{ item.sdnn }}</span>
              <span>SL: {{ item.stresslevel }}</span>
              <span>BP: {{ item.bloodpressuresys }}/{{ item.bloodpressuredia }}</span>
              <span>HbA1c: {{ item.hemoglobina1c }}</span>
            </div>
          </template>
        </van-cell>
      </van-list>
       <van-empty v-else>データありません</van-empty> 
    </div>
  </div>
</template>

<script>
import "vant/es/toast/style";
import "vant/es/dialog/style";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { GetPatientDetails } from "@/services/patient";

export default {
  data() {
    return {
      userInfo: {},
      isInfoBack: false,
    };
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    // this.initUserInfo();
    this.initbinahInfo();
  },
  methods: {
    // initUserInfo() {
    //   GetUserDetails().then((res) => {
    //     this.userInfo = res.data.data.detail;
    //     this.isInfoBack = true;
    //   });
    // },
    initbinahInfo() {
      GetPatientDetails(this.$route.query.patient_id).then((res) => {
        this.userInfo = res.data.data.detail;
        this.isInfoBack = true;
      });
    },
    onClickLeft() {
      history.back();
    },
  },
};
</script>

<style scoped>
   
   
  
#name:focus {
  border: 2px solid #e59700;
}

.item-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: rgb(46, 53, 65)
}

.item-value {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

</style>
